import { defineMessages } from 'react-intl';

export default defineMessages({
  chooseOneFile: {
    id: 'app.containers.Video.VimeoUploader.DragAndDropFile.chooseOneFile',
    defaultMessage: 'Escolher um arquivo',
  },
});
